import React, { useEffect, useState } from "react";
import Card from "components/card";
import { getAgeGrade, updateAgeGrade } from "services/ageGrades";
import { useToast } from "components/Toast";
import { useNavigate, useParams } from "react-router-dom";

const EditAgeGrade: React.FC = () => {
  const { id } = useParams();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    const load = async () => {
      if (!id) return;
      try {
        const { data } = await getAgeGrade(id as string);
        const g = data?.data || data;
        setName(g.name || "");
        setDescription(g.description || "");
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!id) return;
    setSubmitting(true);
    try {
      await updateAgeGrade(id as string, { name, description });
      navigate("/admin/age-grades");
      toast.showSuccess("Age grade updated");
    } catch (err) {
      console.error(err);
      toast.showError("Failed to update age grade");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading)
    return (
      <Card extra="w-full p-4">
        <div>Loading...</div>
      </Card>
    );

  return (
    <Card extra="w-full p-4">
      <h2 className="mb-4 text-2xl font-bold">Edit Age Grade</h2>
      <form onSubmit={handleSubmit} className="max-w-md space-y-4">
        <div>
          <label className="block">Name</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="input"
            required
          />
        </div>
        <div>
          <label className="block">Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="input"
            rows={4}
          />
        </div>
        <div>
          <button
            className="btn btn-primary"
            type="submit"
            disabled={submitting}
          >
            {submitting ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </Card>
  );
};

export default EditAgeGrade;
